import { ajax } from "@/assets/js/ajax";
export function getLitigationStatis (data) {     //案件统计
  return ajax({
    url: 'statis/cause',
    type: 'get',
    data: data
  })
}

// export function getCaseStatis(data) {     //法院统计
//   return ajax({
//     url: 'statis/court',
//     type: 'get',
//     data: data
//   })
// }
export function getCaseStatis (data) {     //法院统计
  return ajax({
    url: 'statis/courtCause/index',
    type: 'get',
    data: data
  })
}

export function getCostStatis (data) {     //标的费用统计
  return ajax({
    url: 'statis/fee',
    type: 'get',
    data: data
  })
}

export function getCensusStatis (data) {     //户籍统计
  return ajax({
    url: 'statis/census',
    type: 'get',
    data: data
  })
}

export function getCarStatis (data) {     //车型统计
  return ajax({
    url: 'statis/car',
    type: 'get'
  })
}

export function getSexStatis (data) {     //性别统计
  return ajax({
    url: 'statis/debtor_sex',
    type: 'get'
  })
}

// export function listbycourt(data) {     
//   return ajax({
//     url: 'cause/listbycourt',
//     type: 'get',
//     data: data
//   })
// }
export function listbycourt (data) {     //性别统计
  return ajax({
    url: 'statis/courtCause/debtor',
    type: 'get',
    data: data
  })
}

